import React from "react";
import { defineMessage, useIntl } from "react-intl";
import { LineChart } from "../charts/LineChart";
import { withFigureIO } from "../components/figure";
import { metadata } from "../data/data_finance_fig_AID_LICS";
import { datasets } from "../data/data_finance_fig_AID_LICS_datasets";
import { mkGemDataDecoder } from "../domain";
import { useMedia } from "../hooks";
import * as M from "../materials";
import { breakpoints } from "../materials/consts.stylex";
import { io } from "../prelude";
export * from "../data/data_finance_fig_AID_LICS";
const TargetLevel = io.keyof({
    TOTAL: null,
    BASIC: null
});
const targetLevelLookup = {
    TOTAL: defineMessage({
        id: "fig.finance.AID_LICS.total",
        defaultMessage: "Total"
    }),
    BASIC: defineMessage({
        id: "fig.finance.AID_LICS.basic",
        defaultMessage: "Basic"
    })
};
const targetLevelDetailedLookup = {
    TOTAL: defineMessage({
        id: "fig.finance.AID_LICS.total_detail",
        defaultMessage: "Out of total aid to education"
    }),
    BASIC: defineMessage({
        id: "fig.finance.AID_LICS.basic_detail",
        defaultMessage: "Out of aid to basic education"
    })
};
export const Data = mkGemDataDecoder([
    "value",
    "ind_id",
    "year"
], {
    target_level: TargetLevel
});
export const Chart = ({ data })=>{
    const intl = useIntl();
    const screenMDown = !useMedia(breakpoints.m);
    const entityData = React.useMemo(()=>data.map((x)=>({
                ...x,
                target_level_name: intl.formatMessage(targetLevelLookup[x.target_level]),
                target_level_detailed: intl.formatMessage(targetLevelDetailedLookup[x.target_level])
            })), [
        intl,
        data
    ]);
    return <LineChart tLabel={(s)=>s} height={screenMDown ? M.chartHeight.s : M.chartHeight.m} x="year" yTicks={[
        0,
        0.1,
        0.2,
        0.3,
        0.4
    ]} timeParse="%Y" timeFormat="%Y" numberFormat=".0%" category="datum.target_level_detailed" yAxisLabel={intl.formatMessage(defineMessage({
        id: "going to low-income countries",
        defaultMessage: "going to low-income countries"
    }))} tooltipFormatX={(x)=>x.target_level_name} colorLegend values={entityData} yAxisLabelPadding={20} showTooltip/>;
};
export default withFigureIO({
    url: new URL("../data/data_finance_fig_AID_LICS.json", import.meta.url).href,
    csv: new URL("../data/data_finance_fig_AID_LICS.zip", import.meta.url).href,
    xlsx: new URL("../data/data_finance_fig_AID_LICS.xlsx", import.meta.url).href,
    metadata,
    Data,
    Chart,
    size: "narrow",
    datasets
});
